import React from 'react'

import styles from './styles.module.scss'

import { ReactComponent as StubIcon } from '../../../../assets/images/licences_stub.svg'

const Stub = () => {
  return (
    <div className={styles.wrapper}>
      <StubIcon />

      <p>
        You don't have any licenses yet.
        <br />
        Add a photo of your licenses or fill in the fields
      </p>
    </div>
  )
}

export default Stub
